<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">

                        <div class="card">
                            <div class="card-body">
                                <div header-class="bg-transparent border-light" class="border border-light schedules">
                                    <div class="" style="margin-top: 10px; margin-left: 10px;">
                                        <!-- <form @submit.prevent="checkDuration()"> -->
                                            <form @submit.prevent="handleFormSubmit('lab')">
                                            <h5 class="card-title mb-4">
                                                Collect From Lab
                                                <div class="form-check form-switch float-end">
                                                    <input class="form-check-input" type="checkbox"
                                                        v-model="lab_consultation_checked" />
                                                </div>
                                            </h5>
                                            <div class="row m-0" v-if="lab_consultation_checked">
                                                <div class="col-md-6 col-lg-7 col-xl-7">
                                                    <label>Session Timings <span class="text-danger">*</span></label>
                                                    <div class="table-responsive">

                                                        <table class="table table-bordered w-100">

                                                            <!---- Monday starts-------->
                                                            <tr>
                                                                <td scope="row">Mon</td>
                                                                <td>
                                                                    <div class="row m-0">
                                                                        <div class="col-lg-10">
                                                                            <div class="input-tag"
                                                                                v-for="(session, index) in lab_consultation[0].day"
                                                                                :key="index">
                                                                                <p>{{ session.start | formatTime }} - {{
                                                                                    session.end | formatTime }} <span
                                                                                        @click="removeSession(lab_consultation[0].day, index, 'lab',0)"
                                                                                        class="text-danger"><i
                                                                                            class="fa fa-times-circle"></i></span>
                                                                                </p>
                                                                            </div>
                                                                        </div>
                                                                        <div class="col-lg-2">
                                                                            <button 
                                                                                variant="success" type="button"
                                                                                class="btn btn-success btn-sm"
                                                                                @click="isSessionAddable(0, 'lab')"
                                                                                
                                                                                ><i
                                                                                    class="fa fa-plus-circle"></i></button>
                                                                            <!-- <button class="btn btn-success btn-sm"><i class="fa fa-plus-circle"></i></button> -->
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                            <!---- Monday ends -------->

                                                            <!---- Tuesday starts-------->
                                                            <tr>
                                                                <td>Tue</td>
                                                                <td>
                                                                    <div class="row m-0">
                                                                        <div class="col-lg-10">
                                                                            <div class="input-tag"
                                                                                v-for="(session, index) in lab_consultation[1].day"
                                                                                :key="index">
                                                                                <p>{{ session.start | formatTime }} - {{
                                                                                    session.end | formatTime }} <span
                                                                                        @click="removeSession(lab_consultation[1].day, index, 'lab',1)"
                                                                                        class="text-danger"><i
                                                                                            class="fa fa-times-circle"></i></span>
                                                                                </p>
                                                                            </div>
                                                                        </div>
                                                                        <div class="col-lg-2">
                                                                            <button 
                                                                                variant="success" type="button"
                                                                                class="btn btn-success btn-sm"
                                                                                @click="isSessionAddable(1, 'lab')"><i
                                                                                    class="fa fa-plus-circle"></i></button>
                                                                            <!-- <button class="btn btn-success btn-sm" ><i class="fa fa-plus-circle"></i></button> -->

                                                                        </div>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                            <!---- Tuesday ends-------->

                                                            <!---- Wednesday starts-------->
                                                            <tr>
                                                                <td>Wed</td>
                                                                <td>
                                                                    <div class="row m-0">
                                                                        <div class="col-lg-10">
                                                                            <div class="input-tag"
                                                                                v-for="(session, index) in lab_consultation[2].day"
                                                                                :key="index">
                                                                                <p>{{ session.start | formatTime }} - {{
                                                                                    session.end | formatTime }} <span
                                                                                        @click="removeSession(lab_consultation[2].day, index, 'lab',2)"
                                                                                        class="text-danger"><i
                                                                                            class="fa fa-times-circle"></i></span>
                                                                                </p>
                                                                            </div>
                                                                        </div>
                                                                        <div class="col-lg-2">
                                                                            <button 
                                                                                variant="success" type="button"
                                                                                class="btn btn-success btn-sm"
                                                                                @click="isSessionAddable(2, 'lab')"><i
                                                                                    class="fa fa-plus-circle"></i></button>
                                                                            <!-- <button class="btn btn-success btn-sm" ><i class="fa fa-plus-circle"></i></button> -->
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                            <!---- Wednesday starts-------->

                                                            <!---- Thursday starts-------->
                                                            <tr>
                                                                <td>Thu</td>
                                                                <td>
                                                                    <div class="row m-0">
                                                                        <div class="col-lg-10">
                                                                            <div class="input-tag"
                                                                                v-for="(session, index) in lab_consultation[3].day"
                                                                                :key="index">
                                                                                <p>{{ session.start | formatTime }} - {{
                                                                                    session.end | formatTime }} <span
                                                                                        @click="removeSession(lab_consultation[3].day, index, 'lab',3)"
                                                                                        class="text-danger"><i
                                                                                            class="fa fa-times-circle"></i></span>
                                                                                </p>
                                                                            </div>
                                                                        </div>
                                                                        <div class="col-lg-2">
                                                                            <button 
                                                                                variant="success" type="button"
                                                                                class="btn btn-success btn-sm"
                                                                                @click="isSessionAddable(3, 'lab')"><i
                                                                                    class="fa fa-plus-circle"></i></button>
                                                                            <!-- <button class="btn btn-success btn-sm"><i class="fa fa-plus-circle"></i></button> -->
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                            <!---- Thursday starts-------->

                                                            <!---- Friday starts-------->
                                                            <tr>
                                                                <td>Fri</td>
                                                                <td>
                                                                    <div class="row m-0">
                                                                        <div class="col-lg-10">
                                                                            <div class="input-tag"
                                                                                v-for="(session, index) in lab_consultation[4].day"
                                                                                :key="index">
                                                                                <p>{{ session.start | formatTime }} - {{
                                                                                    session.end | formatTime }} <span
                                                                                        @click="removeSession(lab_consultation[4].day, index, 'lab',4)"
                                                                                        class="text-danger"><i
                                                                                            class="fa fa-times-circle"></i></span>
                                                                                </p>
                                                                            </div>
                                                                        </div>
                                                                        <div class="col-lg-2">
                                                                            <button 
                                                                                variant="success" type="button"
                                                                                class="btn btn-success btn-sm"
                                                                                @click="isSessionAddable(4, 'lab')"><i
                                                                                    class="fa fa-plus-circle"></i></button>
                                                                            <!-- <button class="btn btn-success btn-sm"><i class="fa fa-plus-circle"></i></button> -->
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                            <!---- Friday starts-------->

                                                            <!---- Saturday starts-------->
                                                            <tr>
                                                                <td>Sat</td>
                                                                <td>
                                                                    <div class="row m-0">
                                                                        <div class="col-lg-10">
                                                                            <div class="input-tag"
                                                                                v-for="(session, index) in lab_consultation[5].day"
                                                                                :key="index">
                                                                                <p>{{ session.start | formatTime }} - {{
                                                                                    session.end | formatTime }} <span
                                                                                        @click="removeSession(lab_consultation[5].day, index, 'lab',5)"
                                                                                        class="text-danger"><i
                                                                                            class="fa fa-times-circle"></i></span>
                                                                                </p>
                                                                            </div>
                                                                        </div>
                                                                        <div class="col-lg-2">
                                                                            <button 
                                                                                variant="success" type="button"
                                                                                class="btn btn-success btn-sm"
                                                                                @click="isSessionAddable(5, 'lab')"><i
                                                                                    class="fa fa-plus-circle"></i></button>
                                                                            <!-- <button class="btn btn-success btn-sm"><i class="fa fa-plus-circle"></i></button> -->
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                            <!---- Saturday ends-------->

                                                            <!---- Sunday starts-------->
                                                            <tr>
                                                                <td>Sun</td>
                                                                <td>
                                                                    <div class="row m-0">
                                                                        <div class="col-lg-10">
                                                                            <div class="input-tag"
                                                                                v-for="(session, index) in lab_consultation[6].day"
                                                                                :key="index">
                                                                                <p>{{ session.start | formatTime }} - {{
                                                                                    session.end | formatTime }} <span
                                                                                        @click="removeSession(lab_consultation[6].day, index, 'lab',6)"
                                                                                        class="text-danger"><i
                                                                                            class="fa fa-times-circle"></i></span>
                                                                                </p>
                                                                            </div>
                                                                        </div>
                                                                        <div class="col-lg-2">
                                                                            <button 
                                                                                variant="success" type="button"
                                                                                class="btn btn-success btn-sm"
                                                                                @click="isSessionAddable(6, 'lab')"><i
                                                                                    class="fa fa-plus-circle"></i></button>
                                                                            <!-- <button class="btn btn-success btn-sm"><i class="fa fa-plus-circle"></i></button> -->
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                            <!---- Sunday ends-------->


                                                        </table>
                                                    </div>
                                                </div>
                                                <div class="col-md-6 col-lg-5 col-xl-5 consultation-details">
                                                    <label>Test Duration <span class="text-danger">*</span></label>
                                                    <b-input-group class="mb-3">
                                                        <b-form-input id="example-input" v-model="duration" readonly @input="setTime()" type="text" placeholder="HH:mm" v-bind:class="{ 'is-invalid': Boolean(errors.test_duration) }"></b-form-input>
                                                        <b-input-group-append>
                                                            <b-form-timepicker v-model="duration" @input="setTime()" button-only right :show-seconds="false" :locale="'it'" :hour12="false" format="HH:mm" aria-controls="example-input"></b-form-timepicker>
                                                        </b-input-group-append>
                                                        <div v-for="(val, index) in errors.test_duration" :key="index" class="invalid-feedback">
                                                            <p class="mb-0">{{ val }}</p>
                                                        </div>
                                                    </b-input-group>
                                                    <span class="ms-1"> {{ time_name }}</span>

                                                    <!-- <b-form-input v-model="duration" type="time"
                                                        @change="setTime()" v-bind:class="{ 'is-invalid': Boolean(errors.test_duration) }"></b-form-input>
                                                    <span class="ms-1"> {{ time_name }}</span>
                                                    <div v-for="(val, index) in errors.test_duration" :key="index" class="invalid-feedback">
                                                        <p class="mb-0">{{ val }}</p>
                                                    </div> -->
                                                    <!-- </b-col>
                                            
                                            </b-row> -->

                                                    <!-- <div class="form-group">
                                                    <label>Commission (in Rs.)<span class="text-danger">*</span></label>
                                                    <input type="text" class="form-control" v-model="video.commision" v-bind:class="{ 'is-invalid': Boolean(errors.commision) }"/>
                                                    <div v-for="(val, index) in errors.commision" :key="index" class="invalid-feedback">
                                                        <p class="mb-0">{{ val }}</p>
                                                    </div>
                                                </div>    -->

                                                </div>
                                                <div class="col-12 my-2">
                                                   <div class="page-loader" v-if="!loading">
                                                      <button type="submit" class="btn btn-primary me-2">Submit</button>
                                                      <!-- <router-link :to="{ name: 'doctors' }" class="btn btn-light">Cancel</router-link> -->
                                                   </div>
                                                   <div class="page-loader" v-else>
                                                      <img src="@/assets/images/preloaderspin.gif"/>
                                                   </div>
                                                </div>
                                            </div>


                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="card">
                            <div class="card-body">
                                <div header-class="bg-transparent border-light" class="border border-light schedules">
                                    <div class="" style="margin-top: 10px; margin-left: 10px;">
                                        <!-- <form @submit.prevent="addHomeSchedule()"> -->
                                        <form @submit.prevent="handleFormSubmit('home')">
                                                <h5 class="card-title mb-4">
                                                Collect From Home
                                                <div class="form-check form-switch float-end">
                                                    <input class="form-check-input" type="checkbox"
                                                        v-model="home_consultation_checked" />
                                                </div>
                                            </h5>
                                            <div class="row m-0" v-if="home_consultation_checked">
                                                <div class="col-md-6 col-lg-7 col-xl-7">
                                                    <label>Session Timings <span class="text-danger">*</span></label>
                                                    <div class="table-responsive">

                                                        <table class="table table-bordered w-100">

                                                            <!---- Monday starts-------->
                                                            <tr>
                                                                <td scope="row">Mon</td>
                                                                <td>
                                                                    <div class="row m-0">
                                                                        <div class="col-lg-10">
                                                                            <div class="input-tag"
                                                                                v-for="(session, index) in home_consultation[0].day"
                                                                                :key="index">
                                                                                <p>{{ session.start | formatTime }} - {{session.end | formatTime }} <br> {{session.schedule_name }} - {{session.count }} <span

                                                                                        @click="removeSession(home_consultation[0].day, index, 'home',0)"
                                                                                        class="text-danger"><i
                                                                                            class="fa fa-times-circle"></i></span>
                                                                                </p>
                                                                            </div>
                                                                        </div>
                                                                        <div class="col-lg-2">
                                                                            <button v-b-modal.session-modal
                                                                                variant="success" type="button"
                                                                                class="btn btn-success btn-sm"
                                                                                @click="day = 0, type = 'home'"><i
                                                                                    class="fa fa-plus-circle"></i></button>
                                                                            <!-- <button class="btn btn-success btn-sm"><i class="fa fa-plus-circle"></i></button> -->
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                            <!---- Monday ends -------->

                                                            <!---- Tuesday starts-------->
                                                            <tr>
                                                                <td>Tue</td>
                                                                <td>
                                                                    <div class="row m-0">
                                                                        <div class="col-lg-10">
                                                                            <div class="input-tag"
                                                                                v-for="(session, index) in home_consultation[1].day"
                                                                                :key="index">
                                                                                <p>{{ session.start | formatTime }} - {{session.end | formatTime }} <br> {{session.schedule_name }} - {{session.count }} <span

                                                                                        @click="removeSession(home_consultation[1].day, index, 'home',1)"
                                                                                        class="text-danger"><i
                                                                                            class="fa fa-times-circle"></i></span>
                                                                                </p>
                                                                            </div>
                                                                        </div>
                                                                        <div class="col-lg-2">
                                                                            <!-- <button v-b-modal.session-modal variant="success" class="btn-sm" @click="day=1, type='video'"><i class="fa fa-plus-circle"></i></button> -->
                                                                            <button v-b-modal.session-modal
                                                                                variant="success" type="button"
                                                                                class="btn btn-success btn-sm"
                                                                                @click="day = 1, type = 'home'"><i
                                                                                    class="fa fa-plus-circle"></i></button>

                                                                        </div>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                            <!---- Tuesday ends-------->

                                                            <!---- Wednesday starts-------->
                                                            <tr>
                                                                <td>Wed</td>
                                                                <td>
                                                                    <div class="row m-0">
                                                                        <div class="col-lg-10">
                                                                            <div class="input-tag"
                                                                                v-for="(session, index) in home_consultation[2].day"
                                                                                :key="index">
                                                                                <p>{{ session.start | formatTime }} - {{session.end | formatTime }} <br> {{session.schedule_name }} - {{session.count }} <span

                                                                                        @click="removeSession(home_consultation[2].day, index, 'home',2)"
                                                                                        class="text-danger"><i
                                                                                            class="fa fa-times-circle"></i></span>
                                                                                </p>
                                                                            </div>
                                                                        </div>
                                                                        <div class="col-lg-2">
                                                                            <!-- <button v-b-modal.session-modal variant="success" class="btn-sm" @click="day=2, type='video'"><i class="fa fa-plus-circle"></i></button> -->
                                                                            <button v-b-modal.session-modal
                                                                                variant="success" type="button"
                                                                                class="btn btn-success btn-sm"
                                                                                @click="day = 2, type = 'home'"><i
                                                                                    class="fa fa-plus-circle"></i></button>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                            <!---- Wednesday starts-------->

                                                            <!---- Thursday starts-------->
                                                            <tr>
                                                                <td>Thu</td>
                                                                <td>
                                                                    <div class="row m-0">
                                                                        <div class="col-lg-10">
                                                                            <div class="input-tag"
                                                                                v-for="(session, index) in home_consultation[3].day"
                                                                                :key="index">
                                                                                <p>{{ session.start | formatTime }} - {{session.end | formatTime }} <br> {{session.schedule_name }} - {{session.count }} <span

                                                                                        @click="removeSession(home_consultation[3].day, index, 'home',3)"
                                                                                        class="text-danger"><i
                                                                                            class="fa fa-times-circle"></i></span>
                                                                                </p>
                                                                            </div>
                                                                        </div>
                                                                        <div class="col-lg-2">
                                                                            <!-- <button v-b-modal.session-modal variant="success" class="btn-sm" @click="day=3, type='video'"><i class="fa fa-plus-circle"></i></button> -->
                                                                            <button v-b-modal.session-modal
                                                                                variant="success" type="button"
                                                                                class="btn btn-success btn-sm"
                                                                                @click="day = 3, type = 'home'"><i
                                                                                    class="fa fa-plus-circle"></i></button>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                            <!---- Thursday starts-------->

                                                            <!---- Friday starts-------->
                                                            <tr>
                                                                <td>Fri</td>
                                                                <td>
                                                                    <div class="row m-0">
                                                                        <div class="col-lg-10">
                                                                            <div class="input-tag"
                                                                                v-for="(session, index) in home_consultation[4].day"
                                                                                :key="index">
                                                                                <p>{{ session.start | formatTime }} - {{session.end | formatTime }} <br> {{session.schedule_name }} - {{session.count }} <span

                                                                                        @click="removeSession(home_consultation[4].day, index, 'home',4)"
                                                                                        class="text-danger"><i
                                                                                            class="fa fa-times-circle"></i></span>
                                                                                </p>
                                                                            </div>
                                                                        </div>
                                                                        <div class="col-lg-2">
                                                                            <button v-b-modal.session-modal
                                                                                variant="success" type="button"
                                                                                class="btn btn-success btn-sm"
                                                                                @click="day = 4, type = 'home'"><i
                                                                                    class="fa fa-plus-circle"></i></button>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                            <!---- Friday starts-------->

                                                            <!---- Saturday starts-------->
                                                            <tr>
                                                                <td>Sat</td>
                                                                <td>
                                                                    <div class="row m-0">
                                                                        <div class="col-lg-10">
                                                                            <div class="input-tag"
                                                                                v-for="(session, index) in home_consultation[5].day"
                                                                                :key="index">
                                                                                <p>{{ session.start | formatTime }} - {{session.end | formatTime }} <br> {{session.schedule_name }} - {{session.count }} <span
                                                                                        @click="removeSession(home_consultation[5].day, index, 'home',5)"
                                                                                        class="text-danger"><i
                                                                                            class="fa fa-times-circle"></i></span>
                                                                                </p>
                                                                            </div>
                                                                        </div>
                                                                        <div class="col-lg-2">
                                                                            <!-- <button v-b-modal.session-modal variant="success" class="btn-sm" @click="day=5, type='video'"><i class="fa fa-plus-circle"></i></button> -->
                                                                            <button v-b-modal.session-modal
                                                                                variant="success" type="button"
                                                                                class="btn btn-success btn-sm"
                                                                                @click="day = 5, type = 'home'"><i
                                                                                    class="fa fa-plus-circle"></i></button>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                            <!---- Saturday ends-------->

                                                            <!---- Sunday starts-------->
                                                            <tr>
                                                                <td>Sun</td>
                                                                <td>
                                                                    <div class="row m-0">
                                                                        <div class="col-lg-10">
                                                                            <div class="input-tag"
                                                                                v-for="(session, index) in home_consultation[6].day"
                                                                                :key="index">
                                                                                <p>{{ session.start | formatTime }} -
                                                                                    {{ session.end | formatTime }} <br>
                                                                                    {{ session.schedule_name }} -
                                                                                    {{ session.count }} <span
                                                                                        @click="removeSession(home_consultation[6].day, index, 'home',6)"
                                                                                        class="text-danger"><i
                                                                                            class="fa fa-times-circle"></i></span>
                                                                                </p>
                                                                            </div>
                                                                        </div>
                                                                        <div class="col-lg-2">
                                                                            <!-- <button v-b-modal.session-modal variant="success" class="btn-sm" @click="day=6, type='video'"><i class="fa fa-plus-circle"></i></button> -->
                                                                            <button v-b-modal.session-modal
                                                                                variant="success" type="button"
                                                                                class="btn btn-success btn-sm"
                                                                                @click="day = 6, type = 'home'"><i
                                                                                    class="fa fa-plus-circle"></i></button>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                            <!---- Sunday ends-------->


                                                        </table>
                                                    </div>
                                                </div>
                                                <div class="col-md-6 col-lg-5 col-xl-5 consultation-details">
                                                    <!-- <div class="form-group" >
                                                    <label>Test Duration <span class="text-danger">*</span></label>
                                                    <select class="form-control">
                                                        <option value="">Select</option>
                                                        <option >10 min</option>
                                                        <option >20 min</option>
                                                        <option >30 min</option>
                                                        <option >1 hr</option>
                                                        <option >1 hr</option>
                                                    </select>
                                                    
                                                </div>                   -->

                                                    <!-- <div class="form-group">
                                                    <label>Commission (in Rs.)<span class="text-danger">*</span></label>
                                                    <input type="text" class="form-control" v-model="video.commision" v-bind:class="{ 'is-invalid': Boolean(errors.commision) }"/>
                                                    <div v-for="(val, index) in errors.commision" :key="index" class="invalid-feedback">
                                                        <p class="mb-0">{{ val }}</p>
                                                    </div>
                                                </div>    -->

                                                </div>
                                                <div class="col-12 my-2">
                                                   <div class="page-loader" v-if="!loading">
                                                      <button type="submit" class="btn btn-primary me-2">Submit</button>
                                                      <!-- <router-link :to="{ name: 'doctors' }" class="btn btn-light">Cancel</router-link> -->
                                                   </div>
                                                   <div class="page-loader" v-else>
                                                      <img src="@/assets/images/preloaderspin.gif"/>
                                                   </div>
                                                </div>
                                            </div>


                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>


                    </div>
                </div>
            </div>
        </div>
        <!---- modal starts ---->
        <b-modal ref="session-modal" id="session-modal" title="Add Session" hide-footer @hidden="clearSession()">
            <b-form @submit.prevent="addSession(day, type)">
             <div class="form-group">
                     <b-form-checkbox
                        v-model="same_in_week"
                        name="sameInWeek"
                        value="1"
                        unchecked-value="2"
                     >
                     <span class="ms-2">Same Timing For All Days</span>
                     </b-form-checkbox>
                  </div>
                <b-col md="12" class="form-group">
                    <label class="control-label">Start Time<span class="text-danger">*</span></label>
                    <!-- <b-form-timepicker v-model="start" locale="en" size="sm"></b-form-timepicker>   -->
                    <!-- <b-form-input v-model="start" type="time"></b-form-input> -->
                    <b-input-group class="mb-3">
                        <b-form-input id="example-input" v-model="start" readonly type="text" placeholder="HH:mm"></b-form-input>
                        <b-input-group-append><b-form-timepicker v-model="start" button-only right :show-seconds="false" :locale="'it'" :hour12="false" format="HH:mm" aria-controls="example-input"></b-form-timepicker></b-input-group-append>
                    </b-input-group>
                </b-col>

                <b-col md="12" class="form-group">
                    <label class="control-label">End Time<span class="text-danger">*</span></label>
                    <!-- <b-form-timepicker v-model="end" locale="en" size="sm"></b-form-timepicker> -->
                    <!-- <b-form-input v-model="end" type="time"></b-form-input> -->
                    <b-input-group class="mb-3">
                        <b-form-input id="example-input" v-model="end" readonly type="text" placeholder="HH:mm"></b-form-input>
                        <b-input-group-append><b-form-timepicker v-model="end" button-only right :show-seconds="false" :locale="'it'" :hour12="false" format="HH:mm" aria-controls="example-input"></b-form-timepicker></b-input-group-append>
                    </b-input-group>
                </b-col>

                <b-row md="12" class="form-group" v-if="type == 'home'">
                    <b-col md="6" class="form-group">
                        <label class="control-label">Schedule Name</label>
                        <b-form-input v-model="schedule_name"></b-form-input>
                    </b-col>
                    <b-col md="6" class="form-group">
                        <label class="control-label">Token Count<span class="text-danger">*</span></label>
                        <b-form-input v-model="count"></b-form-input>
                    </b-col>
                </b-row>



                <!-- <b-col md="12" class="form-group" v-if="type=='clinic'">
                  <b-form-checkbox
                     v-model="reserved"
                     value="1"
                     unchecked-value="0"
                  >
                     <span class="ms-2">Reserved Session</span>
                  </b-form-checkbox>
               </b-col> -->

                <!-- <b-col md="12" class="form-group">
                  <label>Reserved For <span class="text-danger">*</span></label>
                  <select class="form-control" v-model="reserved">
                     <option value="1">Token Vending Machine</option>
                     <option value="3">Both </option>
                  </select>
               </b-col> -->

                <b-col md="12">
                    <b-button type="submit" class="me-3" variant="primary"
                        @click="$bvModal.hide('session-modal')">OK</b-button>
                    <b-button class="" variant="light" @click="$bvModal.hide('session-modal')">Cancel</b-button>
                </b-col>

            </b-form>
        </b-modal>
        <!---- modal ends ----->
          <!---- modal starts ---->
       <b-modal ref="pin-modal" id="pin-modal" title="" hide-footer @hidden="clearForm()">
         <b-form @submit.prevent="checkPin()">
            <b-row>  
               <b-col lg="12" class="form-group">
                  <label class="control-label">Pin Number<span class="text-danger">*</span></label>
                  <b-form-input v-model="pin_no" @keypress="numbersOnly" autocomplete="off" maxlength="4" v-bind:class="{ 'is-invalid': Boolean(errors.pin_no) }"></b-form-input>

                  <div v-for="(val, index) in errors.pin_no" :key="index" class="invalid-feedback">
                     <p class="mb-0">{{ val }}</p>
                  </div>
               </b-col>  
               
               <b-col lg="12">
                  <div class="page-loader" v-if="!loading">
                     <b-button type="submit" class="me-3" variant="primary">Submit</b-button>
                     <b-button class="" variant="light" @click="hideModal('pin-modal')">Close</b-button>
                  </div>
                  <div class="page-loader" v-else>
                     <img src="@/assets/images/preloaderspin.gif"/>
                  </div>
               </b-col>
            </b-row>
         </b-form>
      </b-modal>
      <!---- modal ends ----->
    </Layout>
</template>

<script>
import Layout from '../../layouts/main'
import PageHeader from '@/components/page-header'
import appConfig from "@/app.config";
import moment from 'moment'


export default {
    page: {
        title: "Schedules",
        meta: [
            {
                name: "description",
                content: appConfig.description,
            },
        ],
    },
    components: { Layout, PageHeader },

    data() {
        return {
            title: "Schedules",
            items: [
                {
                    text: "Schedules",
                    active: true,
                },
            ],

            lab_consultation_checked: false,
            home_consultation_checked: false,
            duration_check: false,
            set_time: '',
            hour: '',
            minutes: '',
            time_name: '',
            type: '',
            schedule_name: '',
            count: '',
            start: '',
            end: '',
            duration: '',
            home_schedules: [],
            lab_schedules: [],
            home_durations: [],
            lab_durations: [],
            sessions: [],
            durations: [],
            day: null,
            errors: {},
            pin_no: "",
            form_type: '',
            curr_obj: {}, 
            curr_index: "", 
            curr_type: "", 
            curr_day: "",
            loading: false,           
            same_in_week:2,



            lab_consultation: [

                { day: [] },
                { day: [] },
                { day: [] },
                { day: [] },
                { day: [] },
                { day: [] },
                { day: [] },
            ],


            home_consultation: [

                { day: [] },
                { day: [] },
                { day: [] },
                { day: [] },
                { day: [] },
                { day: [] },
                { day: [] },


            ],

            lab: {},
            home: {},


        };
    },

    mounted() {

        this.fetchSchedules();

    },

    created() {
        this.fetchSchedules();

    },

    watch: {
        start() {
        this.start = this.start.split(":").slice(0, 2).join(":");
        },
        end() {
        this.end = this.end.split(":").slice(0, 2).join(":");
        },
        duration() {
        this.duration = this.duration.split(":").slice(0, 2).join(":");
        },
    },
  
    methods: {

        showModal(modal) {
            this.$refs[modal].show();
         },
         
         hideModal(modal) {
            this.$refs[modal].hide();
         },
         numbersOnly(event) {
            let keyCode = event.keyCode;
            if (keyCode < 48 || keyCode > 57) {
               event.preventDefault();
            }
         },
        setTime() {
            this.set_time = this.duration;
            this.hour = this.set_time.split(':')[0];
            this.minutes = this.set_time.split(':')[1];
            this.time_name = this.hour + ' Hour ' + this.minutes + ' minutes ';
            if (this.duration) {
                this.errors.test_duration = null;  
            }
        },

        getToken() {
            if (localStorage.getItem('medicino_clinic')) {
               var medicino_clinic =  JSON.parse(localStorage.getItem('medicino_clinic'));
               if(medicino_clinic.token) {
                  this.token = medicino_clinic.token;
               } else {
                  this.$swal("", "Failed to fetch token, please login again", "error");
                  this.$router.push({ name: "login" });
               }
               
            } else {
               this.$swal("", "Session expired, please login again", "error");
               this.$router.push({ name: "login" });
            }
	}, 

        fetchSchedules() {


            let url = "clinic/lab/schedule/index?lab_id=" + this.$route.params.id;
            this.getToken();
            this.loading = true;
            this.$axios
                .get(url, { headers: { Authorization: "Bearer " + this.token } })
                .then((res) => {
                    var responseData = res.data.data;
                    console.log(responseData); // Log the entire response



                    this.lab_schedules = responseData.labSchedule;
                    if (this.lab_schedules) {
                        this.lab_consultation_checked = true;


                        if (this.lab_schedules.length) {
                            this.duration = this.lab_schedules[0].test_duration;
                            this.setConsultations('lab');
                            this.lab_durations = this.lab_schedules.test_duration;

                        }


                    } else {

                        this.lab = this.consultation;
                        this.lab_durations = this.active_durations;

                    }

                    this.home_schedules = responseData.homeSchedule;

                    if (this.home_schedules) {
                        this.home_consultation_checked = true;


                        if (this.home_schedules.length) {
                            this.setConsultations('home');
                            this.home_durations = this.home_schedules.duration;
                        }
                    } else {
                        this.home = this.consultation;
                        this.home_durations = this.active_durations;
                    }




                })
                .catch((error) => {

                    if (error.response) {
                        if (error.response.data.message) {

                            if (typeof error.response.data.message === 'object') {
                                console.log(error.response.status);
                            } else {
                                this.$swal("", error.response.data.message, "error");
                            }
                        }
                        else {
                            this.$swal("", "Something went wrong", "error");
                        }
                    } else {
                        this.$swal("", "Something went wrong", "error");
                    }

                })
                .finally(() => (this.loading = false));


        },

            to24HourFormat(timeStr) {
            const [time, modifier] = timeStr.split(' ');
            let [hours, minutes] = time.split(':').map(Number);

            if (modifier === 'PM' && hours !== 12) {
                hours += 12;
            }
            if (modifier === 'AM' && hours === 12) {
                hours = 0;
            }

            return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
        },

        setConsultations(type) {
            var sessions;
            var consultation = [
                { day: [] },
                { day: [] },
                { day: [] },
                { day: [] },
                { day: [] },
                { day: [] },
                { day: [] },
            ];
            var schedules = [];

            if (type == 'lab') {
                sessions = this.lab_schedules;
            } else {
                sessions = this.home_schedules;
            }

            sessions.forEach(obj => {
                var session = {};
                session.start = moment(obj.start_time, 'HH:mm:ss').format('h:mm A');
                session.end = moment(obj.end_time, 'HH:mm:ss').format('h:mm A');
                session.session_id = obj.schedule_id;
                session.day = obj.day_id;
                session.duration = obj.test_duration;
                session.schedule_name = obj.schedule_name;
                session.count = obj.token_count;
                session.collecting_type = obj.collecting_type;
                session.lab_id = obj.lab_id;

                var set_time = obj.test_duration;
                var hour = set_time.split(':')[0];
                var minutes = set_time.split(':')[1];

                if (hour != '00') {
                    session.time_name = hour + ' Hr ' + minutes + ' min ';
                } else {
                    session.time_name = minutes + ' min ';
                }

                var index = parseInt(obj.day_id) - 1;
                consultation[index].day.push(session);

                var schedule = {};
                schedule.day = obj.day_id;
                schedule.start = moment.utc('2002-02-02 ' + obj.start_time).format('HH:mm:ss');
                schedule.end = moment.utc('2002-02-02 ' + obj.end_time).format('HH:mm:ss');
                schedule.duration = obj.test_duration;
                schedule.schedule_name = obj.schedule_name;
                schedule.count = obj.token_count;
                schedule.collecting_type = obj.collecting_type;
                schedule.lab_id = obj.lab_id;
                schedules.push(schedule);
            });

            if (type == 'lab') {
                this.lab_consultation = consultation;
                this.lab_schedules = schedules;
            } else {
                this.home_consultation = consultation;
                this.home_schedules = schedules;
            }
        },

        addSession(day, type) {

            this.day = day;
            this.type = type;


            //var datetime1 = '2002-02-02 ' + this.start;
            //var start = moment.utc(datetime1).format('hh:mm A'); // Use 'HH' for 24-hour format
            //var datetime2 = '2002-02-02 ' + this.end;
            //var end = moment.utc(datetime2).format('hh:mm A'); 
            
            if (this.start > this.end) {
                this.$swal("", "Invalid time slot", "error");
                return;
            }
                   if (this.start == this.end) {
                this.$swal("", "Invalid time error", "error");
                return;
            }
          const hasOverlap = (newstart, newend, slots) => {
            return slots.some(slot => {
                const formattedStartTime = moment(slot.start, 'hh:mm A').format('HH:mm:ss');
                const formattedEndTime = moment(slot.end, 'hh:mm A').format('HH:mm:ss');

                return (
                    (newstart > formattedStartTime && newstart < formattedEndTime) ||  // new start inside existing
                    (newend > formattedStartTime && newend < formattedEndTime) ||      // new end inside existing
                    (formattedStartTime >= newstart && formattedEndTime <= newend) ||  // existing fully inside new
                    (newstart === formattedStartTime && newend === formattedEndTime)   // exact match
                );
            });
        };

            const hasOverlapWithoutSame = (newstart, newend, slots) => {
                console.log('newstart',newstart);
                console.log('newend',newend);
               return slots.some(slot => {
                    console.log('slot_start', slot.start);
                    console.log('slot_end', slot.end);
                    var formattedStartTime = moment(slot.start, 'hh:mm A').format('HH:mm:ss');
                    var formattedEndTime = moment(slot.end, 'hh:mm A').format('HH:mm:ss');
                    console.log('formattedStartTime', formattedStartTime);
                    console.log('formattedEndTime', formattedEndTime);
                    return (
                        (newstart > formattedStartTime && newstart < formattedEndTime) ||  // Partial overlap: new start is within range
                        (newend > formattedStartTime && newend < formattedEndTime) ||      // Partial overlap: new end is within range
                        (formattedStartTime > newstart && formattedEndTime < newend)       // Fully inside new slot
                    );
                });
            };

             const checkExactMatch = (newstart, newend, slots) => {
               const exactMatch = slots.find(slot => {
                  if (newstart === slot.start && newend === slot.end) {
                     return true;
                  }
                  return false; // Ensure other slots are checked
               });
               if (exactMatch) {
                 return true; // If duration doesn't match, return false
               }
               return false; // No exact match found
            };



            /////////////////
            //Checking if slot time already present in any of the consultation types starts

            var invalid = false;

            // Object.entries(this.home_consultation).forEach(([key, val]) => {
            //     if (key == this.day) {
            //         for (var i = 0; i < val['day'].length; i++) {

            //             if (this.start >= val['day'][i].start && this.start <= val['day'][i].end ||
            //                 this.end >= val['day'][i].start && this.end <= val['day'][i].end ||
            //                 val['day'][i].start >= this.start && val['day'][i].start <= this.end) {
            //                 invalid = true;
            //                 break;
            //             }

            //         }
            //     }
            // });
            // Object.entries(this.lab_consultation).forEach(([key, val]) => {
            //     if (key == this.day) {
            //         for (var i = 0; i < val['day'].length; i++) {

            //             if (this.start >= val['day'][i].start && this.start <= val['day'][i].end ||
            //                 this.end >= val['day'][i].start && this.end <= val['day'][i].end ||
            //                 val['day'][i].start >= this.start && val['day'][i].start <= this.end) {
            //                 invalid = true;
            //                 break;
            //             }
            //         }
            //     }
            // });

              if (this.type === 'home') {
                Object.entries(this.home_consultation).forEach(([key, val]) => {
                    const newstart = this.start + ":00";
                    const newend = this.end + ":00";
                    const slots = val['day'];

                    if (this.same_in_week === 2 && key === this.day) {
                        if (hasOverlap(newstart, newend, slots)) {
                            invalid = true;
                            console.log('hasOverlap');
                            return; // early exit from forEach
                        }
                    } else {
                        if (hasOverlapWithoutSame(newstart, newend, slots)) {
                            invalid = true;
                            console.log('hasOverlapWithoutSame');
                            return;
                        }

                        if (checkExactMatch(newstart, newend, slots)) {
                            console.log('Exact match');
                            return;
                        }
                    }
                });
            }

        if (this.type == 'lab') {
            const newstart = this.start + ":00";
            const newend = this.end + ":00";

            for (const [key, val] of Object.entries(this.lab_consultation)) {
                const slots = val['day'];

                if (this.same_in_week === 2 && key === this.day) {
                    if (hasOverlap(newstart, newend, slots)) {
                        invalid = true;
                        console.log('hasOverlap');
                        break; // Stop loop if invalid
                    }
                } else {
                if (hasOverlapWithoutSame(newstart, newend, val['day'])) {
                                invalid = true;
                            }else if (checkExactMatch(newstart, newend, val['day'])) {
                                invalid = false;
                            }
                }
            }
        }



            //Checking if slot time already present in any of the consultation types ends
            /////////////////

            if (this.type == 'home') {
                //Object.entries(this.home_consultation).forEach(([key, val]) => {
                //    if (key == this.day) {
                //        if (!invalid) {
                //            val['day'].push({ start: start, end: end, day: this.day + 1, schedule_name: this.schedule_name, count: this.count });
                //            this.home_schedules.push({ day: this.day + 1, start: this.start + ':00', end: this.end + ':00', schedule_name: this.schedule_name, count: this.count });
                //        } else {
                //            this.$swal("", "Time already included in home schedules", "error");
                //        }
                //    }
                //});
                 Object.entries(this.home_consultation).forEach(([key, val]) => {
                    const newStart = this.start + ':00';
                    const newEnd = this.end + ':00';
                    

                    if (this.same_in_week == 2) {
                        if (key == this.day) {
                            if (!invalid) {
                                val['day'].push({
                                    start: this.start + ':00',
                                    end: this.end + ':00',
                                    day: this.day + 1, schedule_name: this.schedule_name, count: this.count 
                                });

                                this.home_schedules.push({
                                    day: this.day + 1,
                                    start: this.start + ':00',
                                    end: this.end + ':00'
                                    , schedule_name: this.schedule_name, count: this.count 
                                });
                            } else {
                                this.$swal("", "Time already included in home schedules", "error");
                            }
                        }
                    } else {
                        const formattedDay = Number(key) + 1;

                        if (!invalid) {
                            
                        const alreadyIncluded = val['day'].some(slot => {
                            const slotStart24 = this.to24HourFormat(slot.start);
                            const slotEnd24 = this.to24HourFormat(slot.end);

                            return (
                                slotStart24 === this.start &&
                                slotEnd24 === this.end &&
                                slot.day === formattedDay
                            );
                        });


                            if (!alreadyIncluded) {
                                val['day'].push({
                                    start: newStart,
                                    end: newEnd,
                                    day: formattedDay, schedule_name: this.schedule_name, count: this.count
                                });

                                this.home_schedules.push({
                                    day: formattedDay,
                                    start: newStart,
                                    end: newEnd
                                    , schedule_name: this.schedule_name, count: this.count 
                                });
                            }
                        } else {
                            this.$swal("", "Time already included in home schedules", "error");
                        }
                    }
                });

                
            } else {
              Object.entries(this.lab_consultation).forEach(([key, val]) => {
                    const newStart = this.start + ':00';
                    const newEnd = this.end + ':00';
                    

                    if (this.same_in_week == 2) {
                        if (key == this.day) {
                            if (!invalid) {
                                val['day'].push({
                                    start: this.start + ':00',
                                    end: this.end + ':00',
                                    day: this.day + 1,
                                });

                                this.lab_schedules.push({
                                    day: this.day + 1,
                                    start: this.start + ':00',
                                    end: this.end + ':00',
                                });
                            } else {
                                this.$swal("", "Time already included in lab schedules", "error");
                            }
                        }
                    } else {
                        const formattedDay = Number(key) + 1;

                        if (!invalid) {
                            
                        const alreadyIncluded = val['day'].some(slot => {
                            const slotStart24 = this.to24HourFormat(slot.start);
                            const slotEnd24 = this.to24HourFormat(slot.end);

                            return (
                                slotStart24 === this.start &&
                                slotEnd24 === this.end &&
                                slot.day === formattedDay
                            );
                        });


                            if (!alreadyIncluded) {
                                val['day'].push({
                                    start: newStart,
                                    end: newEnd,
                                    day: formattedDay,
                                });

                                this.lab_schedules.push({
                                    day: formattedDay,
                                    start: newStart,
                                    end: newEnd,
                                });
                            }
                        } else {
                            this.$swal("", "Time already included in lab schedules", "error");
                        }
                    }
                });

            }
            this.clearSession();
            this.$refs['session-modal'].hide();
        },

        clearSession() {
            this.start = '';
            this.end = '';
            this.day = null;
            this.type = '';
            // this.duration = '';
            this.schedule_name = '';
            this.count = '';
            this.errors= {};
            this.pin_no = ''; 
            this.form_type = ''; 
            this.curr_obj = {}; 
            this.curr_index = '';  
            this.curr_type = '';  
            this.curr_day = ''; 
            this.same_in_week = 2;
        },
        clearForm() {
            this.errors = {};
            this.pin_no = ''; 
            this.form_type = ''; 
         },
        handleFormSubmit(form_type) {
            this.showModal("pin-modal");
            this.form_type = form_type;         
         },
         checkPin() {
            this.getToken();           
            
            const config = {
               headers: {
                  "Content-type": "multipart/form-data",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            let url = "api/check_pin_no";

            let formData = new FormData();
            formData.append("pin_no", this.pin_no);
            this.loading = true;
            
            this.$axios
            .post(url, formData, config)
            .then((response) => {
                  if (response.data.status) {
                    //  this.$swal("", response.data.message, "success");
                     this.hideModal('pin-modal');
                     if(this.form_type == 'lab'){
                        this.checkDuration();
                     }else if(this.form_type == 'home'){
                        this.addHomeSchedule();
                     }else if(this.form_type == 'remove'){
                        this.removeSessionConfirm(this.curr_obj, this.curr_index, this.curr_type, this.curr_day);
                     }
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
               })
               .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        this.errors = error.response.data.message;
                        //console.log(this.errors);
                        this.$swal("", error.response.data.message, "error");

                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               })
               .finally(() => (this.loading = false));
         }, 

        addHomeSchedule() {

            this.getToken();

            const config = {
                headers: {
                    "Content-type": "multipart/form-data",
                    "Accept": "application/json",
                    "Authorization": "Bearer " + this.token,
                },
            };

            let url = "clinic/lab/schedule/home";

            let formData = new FormData();
            formData.append("lab_id", this.$route.params.id);
            formData.append("schedules", JSON.stringify(this.home_schedules));

            this.loading = true;

            this.$axios
            .post(url, formData, config)
                .then((response) => {
                    if (response.data.status) {
                        this.$swal("", response.data.message, "success");
                        this.clearSession();

                    } else {
                        this.$swal("", response.data.message, "error");
                    }
                    this.fetchSchedules();

                })
                .catch((error) => {

                if (error.response) {
                    if (error.response.data.message) {

                        if (typeof error.response.data.message === 'object') {
                            this.errors = error.response.data.message;
                            console.log(error.response.status);
                        } else {
                            this.$swal("", error.response.data.message, "error");
                        }
                    }
                    else {
                        this.$swal("", "Something went wrong", "error");
                    }
                } else {
                    this.$swal("", "Something went wrong", "error");
                }

                })
                .finally(() => (this.loading = false));



        },

        checkDuration() {

            this.duration_check = false;

            Object.entries(this.lab_schedules).forEach(([key, val]) => {
                console.log('Key:', key);

                let startingTime = moment(val.start, 'HH:mm');
                let endingTime = moment(val.end, 'HH:mm');

                let schedule_duration = moment.duration(endingTime.diff(startingTime)).asMinutes();
                let reserved_duration = moment.duration(this.duration).asMinutes();

                if (reserved_duration > schedule_duration) {
                    this.duration_check = true;
                }
            });

            if(this.duration_check){
                this.$swal("", "Test duration is greater than slot duration!", "error");
            }else {
                this.addLabSchedule();
            }
        
        },


        addLabSchedule() {

            this.getToken();

            const config = {
                headers: {
                    "Content-type": "multipart/form-data",
                    "Accept": "application/json",
                    "Authorization": "Bearer " + this.token,
                },
            };

            let url = "clinic/lab/schedule/lab";

            let formData = new FormData();

            formData.append("lab_id", this.$route.params.id);
            formData.append("test_duration", this.duration);
            formData.append("schedules", JSON.stringify(this.lab_schedules));

            this.loading = true;

            this.$axios
            .post(url, formData, config)
                .then((response) => {
                    if (response.data.status) {
                        this.$swal("", response.data.message, "success");
                        this.clearSession();
                    } else {
                        this.$swal("", response.data.message, "error");
                    }
                    this.fetchSchedules();
                })
                .catch((error) => {
                if (error.response) {
                    if (error.response.data.message) {
                        if (typeof error.response.data.message === 'object') {
                            this.errors = error.response.data.message;
                            console.log(error.response.status);
                            const errorMessage = error.response.data.message.join(', '); // Convert array to comma-separated string
                            this.$swal("", errorMessage, "error");
                        } else {
                            this.$swal("", error.response.data.message, "error");
                        }
                    } else {
                        this.$swal("", "Something went wrong", "error");
                    }
                } else {
                    this.$swal("", "Something went wrong", "error");
                }
            })
            .finally(() => (this.loading = false));

            

        },
        removeSession(obj, index, type, day) {
            this.curr_obj = obj;
            this.curr_index = index;
            this.curr_type = type;
            this.curr_day = day;
            this.handleFormSubmit('remove');
        },

        removeSessionConfirm(obj, index, type, day) {

            var session = obj[index];
            
            var startTime = moment.utc('2002-02-02 ' + session.start).format('HH:mm:ss');
            var endTime = moment.utc('2002-02-02 ' + session.end).format('HH:mm:ss');
            var ctype;
            if(type == 'lab'){
                ctype = 1;
            }else{
                ctype = 2;
            }
            var day_id;
            if (day== 6){
                day_id = 1;
            }else{
                day_id = day + 2;
            }

            this.getToken();
            const config = {
                headers: {
                    "Accept": "application/json",
                    "Authorization": "Bearer " + this.token,
                },
            };

            let url = "clinic/lab/schedule/isDeletable?type=" + ctype + "&end_time=" + endTime + "&start_time=" + startTime + "&lab_id=" + this.$route.params.id + "&day=" + day_id ;
            this.$axios
                .get(url, config)
                .then((response) => {
                    console.log(response);
                    if (response.data.status) {

                        if (type == 'lab') {

                            this.lab_schedules.forEach(lab => {
                                if (session.day == lab.day &&
                                    startTime == lab.start &&
                                    endTime == lab.end) {
                                        this.lab_schedules.splice(index, 1);
                                        if(session.session_id){
                                            this.deleteSession(obj, index);
                                        }
                                }
                            });

                        }else {

                            this.home_schedules.forEach(home => {
                                if (session.day == home.day &&
                                    startTime == home.start &&
                                    endTime == home.end) {
                                        this.home_schedules.splice(index, 1);
                                        if(session.session_id){
                                        this.deleteSession(obj, index);
                                        }
                                }
                            });
                        }



                    obj.splice(index, 1);

                    } else {
                        this.$swal("", response.data.message, "error");
                    }
                    this.fetchSchedules();

                })
                .catch((error) => {
                    if (error.response) {
                        console.log(error.response);
                        if (error.response.status == 400) {
                            this.$swal("", error.response.data.message, "error");
                        } else {
                            if (error.response.data.message) {
                                this.errors = error.response.data.message;
                                //console.log(this.errors);
                                this.$swal("", "Something went wrong", "error");
                            } else {
                                this.$swal("", "Something went wrong", "error");
                            }
                        }
                    } else {
                        this.$swal("", "Something went wrong", "error");
                    }
                })
                .finally(() => (this.loading = false));
           

        },

        isSessionAddable(day, type) {
            // alert(day);
            this.day = day;
            this.type = type;

            this.getToken();          
            const config = {
               headers: {
                  "Content-type": "multipart/form-data",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };
            var ctype = 0;
            if(type == 'lab') {
               ctype = 1;
            } else {
               ctype = 2;
            }
            var day_id;
            if (day== 6){
                day_id = 1;
            }else{
                day_id = day + 2;
            }
            let formData = new FormData();
            formData.append("lab_id", this.$route.params.id); 
            formData.append("type", ctype); 
            formData.append("day", day_id); 

            let url = "clinic/lab/schedule/isSLotAddable"; 
            this.$axios
            .post(url, formData, config)
            .then((response) => {
                  console.log(response);
                  if (response.data.status) {
                     this.showModal('session-modal');
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
            })
            .catch((error) => {
                  if (error.response) {
                     console.log(error.response);
                     if(error.response.status == 400) {
                        this.$swal("", error.response.data.message, "error");
                     } else {
                        if (error.response.data.message) {
                           //this.errors = error.response.data.message;
                           //console.log(this.errors);
                           this.$swal("", "Something went wrong", "error");
                        } else {
                           this.$swal("", "Something went wrong", "error");
                        }
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
            })
            .finally(() => (this.loading = false)); 
         },

        deleteSession(obj, index){

            var session = obj[index];


            this.getToken();
            const config = {
                headers: {
                    "Accept": "application/json",
                    "Authorization": "Bearer " + this.token,
                },
            };



            let url = "clinic/lab/schedule/delete?id=" + session.session_id;
            this.$axios
                .get(url, config)
                .then((response) => {
                    console.log(response);
                    if (response.data.status) {

                        this.$swal("", response.data.message, "success");
                        this.clearSession();

                    } else {
                        this.$swal("", response.data.message, "error");
                    }
                    this.fetchSchedules();

                })
                .catch((error) => {
                    if (error.response) {
                        console.log(error.response);
                        if (error.response.status == 400) {
                            this.$swal("", error.response.data.message, "error");
                        } else {
                            if (error.response.data.message) {
                                this.errors = error.response.data.message;
                                //console.log(this.errors);
                                this.$swal("", "Something went wrong", "error");
                            } else {
                                this.$swal("", "Something went wrong", "error");
                            }
                        }
                    } else {
                        this.$swal("", "Something went wrong", "error");
                    }
                })
                .finally(() => (this.loading = false));


        }



    }

}
</script>